// Contract ABIs for V2 contracts
export const ETCPOWv2ABI = [
  "function balanceOf(address account) view returns (uint256)",
  "function transfer(address to, uint256 amount) returns (bool)",
  "function transferFrom(address from, address to, uint256 amount) returns (bool)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function allowance(address owner, address spender) view returns (uint256)",
  "function burn(uint256 amount)",
  "function totalSupply() view returns (uint256)"
];

export const VirtualNodeNFTABI = [
  "function balanceOf(address owner) view returns (uint256)",
  "function tokenOfOwnerByIndex(address owner, uint256 index) view returns (uint256)",
  "function getNodeStats(uint256 tokenId) view returns (tuple(uint256 tokenId, uint256 hashPower, uint256 bandwidth, uint256 uptime, uint256 lastClaimTime, uint256 totalEarned, uint8 tier, bool isActive, uint256 activationTime, uint256 deactivationTime))",
  "function calculatePendingRewards(uint256 tokenId) view returns (uint256)",
  "function rewardRatePerHour() view returns (uint256)",
  "function activeDuration() view returns (uint256)",
  "function isNodeExpired(uint256 tokenId) view returns (bool)",
  "function getTimeUntilDeactivation(uint256 tokenId) view returns (uint256)",
  "function getNodesByOwner(address owner) view returns (uint256[])",
  "function ownerOf(uint256 tokenId) view returns (address)",
  "function mintNode(address to, uint8 tier) returns (uint256)",
  "function setActive(uint256 tokenId, bool active)",
  "function upgradeNodeStat(uint256 tokenId, string stat, uint256 amount)",
  "function updateLastClaimTime(uint256 tokenId)",
  "function addTotalEarned(uint256 tokenId, uint256 amount)",
  "function gameLogic() view returns (address)",
  "function setGameLogic(address _gameLogic)",
  "function maxHashPower(uint8 tier) view returns (uint256)",
  "function maxBandwidth(uint8 tier) view returns (uint256)",
  "function maxUptime(uint8 tier) view returns (uint256)",
  "function setMaxStatsForTier(uint8 tier, uint256 hashPower, uint256 bandwidth, uint256 uptime)",
  "function setAllMaxStats(uint256[] memory hashPowers, uint256[] memory bandwidths, uint256[] memory uptimes)",
  "function totalSupply() view returns (uint256)",
  "function tokenURI(uint256 tokenId) view returns (string)"
];

export const UpgradeNFTABI = [
  "function balanceOf(address owner) view returns (uint256)",
  "function tokenOfOwnerByIndex(address owner, uint256 index) view returns (uint256)",
  "function getUpgradeDetails(uint256 tokenId) view returns (tuple(uint256 tokenId, string upgradeName, string statAffected, uint256 boostAmount, uint8 rarity))",
  "function getUpgradesByOwner(address owner) view returns (uint256[])",
  "function getUpgradesByOwner(address owner) view returns (uint256[])",
  "function ownerOf(uint256 tokenId) view returns (address)",
  "function mintUpgrade(address to, string upgradeName, string statAffected, uint256 boostAmount, uint8 rarity) returns (uint256)",
  "function burn(uint256 tokenId)",
  "function gameLogic() view returns (address)",
  "function setGameLogic(address _gameLogic)",
  "function totalSupply() view returns (uint256)",
  "function tokenURI(uint256 tokenId) view returns (string)",
  "event UpgradeMinted(address indexed to, uint256 indexed tokenId, string name, uint8 rarity)"
];

export const ChestNFTABI = [
  "function balanceOf(address owner) view returns (uint256)",
  "function tokenOfOwnerByIndex(address owner, uint256 index) view returns (uint256)",
  "function getChestDetails(uint256 tokenId) view returns (tuple(uint256 tokenId, uint8 chestTier, bool isOpened, uint256 openCost, uint256 mintBlock))",
  "function getChestsByOwner(address owner) view returns (uint256[])",
  "function ownerOf(uint256 tokenId) view returns (address)",
  "function mintChest(address to, uint8 tier, uint256 openCost) returns (uint256)",
  "function markAsOpened(uint256 tokenId)",
  "function gameLogic() view returns (address)",
  "function setGameLogic(address _gameLogic)",
  "function totalSupply() view returns (uint256)",
  "function tokenURI(uint256 tokenId) view returns (string)"
];

export const GameLogicV2ABI = [
  "function nodePurchasePrice() view returns (uint256)",
  "function tier2NodePrice() view returns (uint256)",
  "function tier3NodePrice() view returns (uint256)",
  "function tier4NodePrice() view returns (uint256)",
  "function tier5NodePrice() view returns (uint256)",
  "function chestPurchasePrice() view returns (uint256)",
  "function chestTierPrices(uint256) view returns (uint256)",
  "function upgradeBasePrice() view returns (uint256)",
  "function referralReward() view returns (uint256)",
  "function rewardRatePerHour() view returns (uint256)",
  "function reactivationFee() view returns (uint256)",
  "function protocolFeeBps() view returns (uint256)",
  "function treasury() view returns (address)",
  "function MAX_PROTOCOL_FEE_BPS() view returns (uint256)",
  "function paused() view returns (bool)",
  "function purchaseStarterNode(string referralCode)",
  "function purchaseTier2Node(string referralCode)",
  "function purchaseTier3Node(string referralCode)",
  "function purchaseTier4Node(string referralCode)",
  "function purchaseTier5Node(string referralCode)",
  "function purchaseChest(uint8 tier)",
  "function openChest(uint256 chestId)",
  "function applyUpgrade(uint256 nodeId, uint256 upgradeId)",
  "function claimNodeRewards(uint256 nodeId)",
  "function claimMultipleNodeRewards(uint256[] nodeIds)",
  "function toggleNodeActive(uint256 nodeId)",
  "function owner() view returns (address)",
  "function generateReferralCode(address user)",
  "function getReferralStats(address user) view returns (string memory referralCode, uint256 totalReferrals, uint256 activeReferrals, uint256 totalRewardsEarned)",
  "function getReferralsByReferrer(address referrer) view returns (address[] memory)",
  "function referralCodeExists(string memory code) view returns (bool)",
  "function setAchievements(address _achievements)",
  "function setLeaderboard(address _leaderboard)",
  "function updateLeaderboardEntry(address player, uint256 totalNodes, uint256 totalHashPower, uint256 totalRewardsClaimed, uint256 achievementPoints, uint256 totalSpent)",
  "function etcpowv2Token() view returns (address)",
  "function nodeNFT() view returns (address)",
  "function upgradeNFT() view returns (address)",
  "function chestNFT() view returns (address)",
  "function rewardsPool() view returns (address)",
  "function achievements() view returns (address)",
  "function leaderboard() view returns (address)",
  "function setNodePurchasePrice(uint256 newPrice)",
  "function setTier2NodePrice(uint256 newPrice)",
  "function setTier3NodePrice(uint256 newPrice)",
  "function setTier4NodePrice(uint256 newPrice)",
  "function setTier5NodePrice(uint256 newPrice)",
  "function setChestPurchasePrice(uint256 newPrice)",
  "function setChestTierPrice(uint8 tier, uint256 newPrice)",
  "function setAllChestTierPrices(uint256 tier1Price, uint256 tier2Price, uint256 tier3Price, uint256 tier4Price, uint256 tier5Price)",
  "function getUpgradeBoost(uint8 rarity) view returns (uint256)",
  "function setUpgradeBoost(uint8 rarity, uint256 boost)",
  "function setAllUpgradeBoosts(uint256[5] memory boosts)",
  "function setRewardRatePerHour(uint256 newRate)",
  "function setUpgradeBasePrice(uint256 newPrice)",
  "function setReferralReward(uint256 newReward)",
  "function setReferralBonus(uint256 newBonus)",
  "function setReactivationFee(uint256 newFee)",
  "function setProtocolFeeBps(uint256 newBps)",
  "function setTreasury(address newTreasury)",
  "function setPaused(bool _paused)",
  "function emergencyWithdrawTokens()",
  "function withdrawTokens(uint256 amount)",
  "function getTimeUntilDeactivation(uint256 nodeId) view returns (uint256)",
  "function pause()",
  "function unpause()",
  "function payoutAchievementReward(address player, uint256 rewardAmount)",
  // Event fragments for filtering and listening
  "event NodePurchased(address indexed player, uint256 indexed nodeId, uint8 tier)",
  "event ChestPurchased(address indexed player, uint256 indexed chestId, uint8 tier)",
  "event ChestOpened(address indexed player, uint256 indexed chestId, uint8 rarity)",
  "event UpgradeApplied(address indexed player, uint256 indexed nodeId, uint256 indexed upgradeId)",
  "event ReferralProcessed(address indexed buyer, string referralCode)",
  "event RewardsClaimed(address indexed player, uint256 indexed nodeId, uint256 amount)",
  "event NodeToggled(address indexed player, uint256 indexed nodeId, bool active)",
  "event ReactivationFeePaid(address indexed player, uint256 indexed nodeId, uint256 amount)",
  "event ProtocolFeeTaken(address indexed payer, uint256 protocolFee, uint256 toPool)",
  "event EmergencyWithdraw(address indexed owner, uint256 amount)"
];

export const AchievementsV2ABI = [
  "function getPlayerAchievements(address player) view returns (bool[] memory unlocked, uint256[] memory progress, uint256 totalUnlocked, uint256 totalRewardsEarned, uint256 firstInteractionTime)",
  "function getAchievement(uint256 achievementId) view returns (string memory name, string memory description, uint256 rewardAmount, uint256 requirement, string memory category, bool isActive, uint256 unlockTime)",
  "function getAllAchievements() view returns (tuple(uint256 id, string name, string description, uint256 rewardAmount, uint256 requirement, string category, bool isActive, uint256 unlockTime)[] memory)",
  "function updateProgress(address player, string memory category, uint256 progress)",
  "function checkAchievements(address player)",
  "function claimOwedAchievementRewards()",
  "function owedAchievementRewards(address player) view returns (uint256)",
  "function achievementCount() view returns (uint256)",
  "function gameLogic() view returns (address)",
  "function setGameLogic(address _gameLogic)",
  "function setETCPOWv2(address _etcpowv2Token)",
  "function setNodeNFT(address _nodeNFT)",
  "function setUpgradeNFT(address _upgradeNFT)",
  "function setChestNFT(address _chestNFT)",
  "function setRewardsPool(address _rewardsPool)",
  "function owner() view returns (address)",
  "function transferOwnership(address newOwner)",
  "function renounceOwnership()",
  "function fundRewards(uint256 amount)",
  "function withdrawExcessTokens(uint256 amount)",
  "function getContractBalance() view returns (uint256)"
  ,
  "function updateAchievementReward(uint256 achievementId, uint256 newRewardAmount)",
  "function updateMultipleAchievementRewards(uint256[] calldata achievementIds, uint256[] calldata newRewardAmounts)"
];

export const RewardsPoolABI = [
  "function getPoolBalance() view returns (uint256)",
  "function getPoolStats() view returns (uint256 balance, uint256 deposited, uint256 paidOut, uint256 remaining)",
  "function payoutReward(address to, uint256 amount)",
  "function deposit(uint256 amount)",
  "function emergencyWithdraw()",
  "function etcpowv2Token() view returns (address)",
  "function gameLogic() view returns (address)",
  "function leaderboard() view returns (address)",
  "function owner() view returns (address)",
  "function totalDeposited() view returns (uint256)",
  "function totalPaidOut() view returns (uint256)",
  "function setGameLogic(address _gameLogic)",
  "function setLeaderboard(address _leaderboard)",
  "function transferOwnership(address newOwner)",
  "function renounceOwnership()"
];

export const LeaderboardABI = [
  "function getTopPlayers(uint256 limit) view returns (tuple(address player, uint256 totalNodes, uint256 totalHashPower, uint256 totalRewardsClaimed, uint256 achievementPoints, uint256 rank, uint256 lastUpdated)[] memory)",
  "function getPlayerRank(address player) view returns (uint256)",
  "function getPlayerEntry(address player) view returns (tuple(address player, uint256 totalNodes, uint256 totalHashPower, uint256 totalRewardsClaimed, uint256 achievementPoints, uint256 rank, uint256 lastUpdated))",
  "function getCurrentSeason() view returns (tuple(uint256 seasonNumber, uint256 startTime, uint256 endTime, bool isActive))",
  "function getLeaderboardStats() view returns (uint256 totalPlayersCount, uint256 totalNodes, uint256 totalHashPower, uint256 totalRewardsClaimed, uint256 totalAchievements, uint256 currentSeasonNumber, uint256 seasonStartTime, uint256 seasonEndTime, bool seasonActive)",
  "function getSeasonHistory(uint256 seasonNumber) view returns (tuple(address player, uint256 totalNodes, uint256 totalHashPower, uint256 totalRewardsClaimed, uint256 achievementPoints, uint256 rank, uint256 lastUpdated)[] memory)",
  "function owner() view returns (address)",
  "function transferOwnership(address newOwner)",
  "function renounceOwnership()"
];
